import { saveAs } from "file-saver";

export function toCsvCell(value) {
  if (value === null || value === undefined) return "";
  const stringValue = String(value);
  // Escape double-quotes and wrap when needed.
  const needsQuotes = /[",\n\r]/.test(stringValue);
  const escaped = stringValue.replace(/"/g, '""');
  return needsQuotes ? `"${escaped}"` : escaped;
}

export function downloadCsv({ headers, data, filename }) {
  const csvContent = [
    headers.map(toCsvCell).join(","),
    ...data.map((row) => headers.map((h) => toCsvCell(row?.[h])).join(",")),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, filename || `table-export-${Date.now()}.csv`);
}

export function getCsvExportOptions(totalCount) {
  // If we don't know the total count, show all options.
  if (typeof totalCount !== "number" || Number.isNaN(totalCount)) {
    return [
      { exportType: "100", label: "Export first 100 rows" },
      { exportType: "50%", label: "Export 50% of the data" },
      { exportType: "100%", label: "Export 100% of the data" },
    ];
  }

  // Rules requested:
  // - < 100         => only 100%
  // - = 100         => only 100 rows
  // - 101..199      => 100% + 100 rows
  // - >= 200        => all three options
  if (totalCount < 100) {
    return [{ exportType: "100%", label: "Export 100% of the data" }];
  }

  if (totalCount === 100) {
    return [{ exportType: "100", label: "Export first 100 rows" }];
  }

  if (totalCount < 200) {
    return [
      { exportType: "100", label: "Export first 100 rows" },
      { exportType: "100%", label: "Export 100% of the data" },
    ];
  }

  return [
    { exportType: "100", label: "Export first 100 rows" },
    { exportType: "50%", label: "Export 50% of the data" },
    { exportType: "100%", label: "Export 100% of the data" },
  ];
}
